export enum PageTypes {
  MAIN,
  PARTY_PLAY,
}
